import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: null,
      myChart: null,
      showLegend: false,
      smallLabelData: [],
      labelData: []
    };
  },
  methods: {
    setLegendShow: function setLegendShow(val) {
      this.showLegend = val;

      if (val) {
        this.option.legend.data = this.labelData;
      } else {
        this.option.legend.data = this.smallLabelData;
      }

      this.myChart.setOption(this.option);
    },
    //selectedObj 是否有自定义不显示的因子 setIndex要展示前几项
    initBarChart: function initBarChart(popArr, time, labelData) {
      var _this = this;

      var selectedObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var setIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;
      var title = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
      console.log('popArr, time, labelData', popArr, time, labelData); // 将累计流量置后,默认不勾选

      var selected = {};
      var normalData = [];
      var flowData = [];

      if (selectedObj) {
        selected = selectedObj;
      } else {
        labelData.forEach(function (item) {
          if (item.indexOf('累计流量') > -1) {
            selected[item] = false;
            flowData.push(item);
          } else {
            selected[item] = true;
            normalData.push(item);
          }
        });
        labelData = normalData.concat(flowData);
      }

      this.labelData = _toConsumableArray(labelData);
      var smallLabelData = labelData.splice(0, setIndex);
      this.smallLabelData = _toConsumableArray(smallLabelData); //	得到仪表盘

      var arrs = [];

      for (var i = 0; i < popArr.length; i++) {
        arrs.push({
          name: popArr[i].title,
          type: 'line',
          symbol: 'circle',
          showSymbol: false,
          symbolSize: 8,
          itemStyle: {
            normal: {
              // color: '#0092f6',
              // lineStyle: {
              //   color: '#0092f6',
              //   width: 1,
              // },
              areaStyle: {
                //color: '#94C9EC'
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0.4,
                  color: 'rgba(7,44,90,0.1)'
                }, {
                  offset: 1,
                  color: 'rgba(0,146,246,0.9)'
                }])
              }
            }
          },
          // markPoint: {
          //   itemStyle: {
          //     normal: {
          //       color: 'red',
          //     },
          //   },
          // },
          data: popArr[i].data
        });
      }

      console.log('arrs', arrs);
      this.option = {
        // backgroundColor: '#11183c',
        grid: {
          // left: '5%',
          // right: '2%',
          // top: '15%',
          // bottom: '15%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#57617B'
            }
          }
        },
        legend: {
          data: this.showLegend ? this.labelData : this.smallLabelData,
          itemWidth: 20,
          itemHeight: 10,
          selected: selected,
          textStyle: {
            fontSize: 14,
            color: '#65aaf1'
          },
          // right: '0', //距离右侧
          top: '0%',
          left: '5%' // lineHeight: '20',

        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#65aaf1'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#0a2b52',
              width: 1
            }
          },

          /*axisTick:{
           	show:false,
           },
           splitLine:{
           	show:true,
            lineStyle:{
            	color:'#195384'
            }
          },*/
          data: time
        }],
        yAxis: [{
          type: 'value',
          name: title,
          axisLabel: {
            color: '#65aaf1' //刻度线标签颜色

          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#65aaf1'
            }
          }
        }],
        series: arrs
      };
      this.chart = this.$refs.chart111;
      this.myChart = this.$echarts.init(this.chart);
      this.myChart.setOption(this.option);
      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    }
  }
};